import { useTranslation } from '@hooks/useTranslation';
import { Integration, IntegrationType } from '@models/integration.model';
import { InfoOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

interface GenerateStructureIntegrationModalProps {
  integration: Integration;
}

const GenerateStructureIntegrationModal: React.FC<GenerateStructureIntegrationModalProps> = ({ integration }) => {
  const localeIntegrations = useTranslation('integrations');

  return (
    <Box>
      <Typography variant="body16semibold" component="h4" marginBottom={2}>
        {localeIntegrations['confirmGenerateMessage']
          .replace('{type}', integration.integrationType)
          .replace('{provider}', integration.integrationProvider)}
      </Typography>
      <Typography variant="body16" component="div" whiteSpace="pre-wrap" marginBottom={3}>
        {integration.integrationType === IntegrationType.CALENDAR &&
          localeIntegrations['confirmGenerateMessageCalendar']}
        {integration.integrationType === IntegrationType.STORAGE && localeIntegrations['confirmGenerateMessageStorage']}
      </Typography>
      <Box className="flex items-start gap-2 p-3 bg-amber-50 border border-amber-300 rounded">
        <InfoOutlined className="text-amber-600 mt-0.5" fontSize="small" />
        <Typography variant="body14" className="text-amber-800">
          {localeIntegrations['confirmGenerateBackgroundNote']}
        </Typography>
      </Box>
    </Box>
  );
};

export default GenerateStructureIntegrationModal;
